module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook.af5475f1.jpg";